module.exports = __webpack_public_path__ + "img/thunderkick.9efe72a9.svg";